import { SHARED_ACTIONS } from 'constants/Actions/Shared';

// Estado inicial del reducer
const aInitialState = {
    oUser: null,
    bUserChecked: false,
}
/**
 * Reducer que sera utilizado para controlar variables globales en el sistema, por ejemplo el loading.
 * 
 * @param {Array} state Estado, si no recibe datos se setea el estado inicial
 * @param {object} action Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const SessionReducer = (state = aInitialState, oAction) => {
    switch (oAction.type) {
        case SHARED_ACTIONS.LOGIN:
            return { ...state, oUser: oAction.data.oUser };
        case SHARED_ACTIONS.CHECK_USERNAME:
            return { ...state, bUserChecked: true };
        case SHARED_ACTIONS.CLEAN:
            return { ...state, bUserChecked: false };
        case SHARED_ACTIONS.LOGOUT:
            return { ...state, oUser: null, bUserChecked: false };
        default:
            return state;
    }
}
